import { sendRawRequest } from "../request/axios";
import { AxiosHttpError } from "../types/error.type";
import { CreateUserData } from "../types/user.type";

export async function createUser(input: CreateUserData) {
  try {
    await sendRawRequest<CreateUserData, never>("post", "/users/", input);
    return {
      success: true,
    };
  } catch (error) {
    const axiosError = error as AxiosHttpError;
    console.log(error);
    return { success: false, error: axiosError.response?.data };
  }
}
